"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createApp;
var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/createForOfIteratorHelper"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _regenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/regenerator"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _utils = require("../common/utils");
function createApp() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wapp = p.wapp;
  var defaultConfig = Object.create(Object.prototype, {});
  var defaultMiddlewares = [function next(req, res, next) {
    if (next) {
      return next();
    }
    return null;
  }];
  function defaultErrorHandler(err, req, res, next) {
    var _app$wapp$log = app.wapp.log,
      log = _app$wapp$log === void 0 ? function () {
        return "";
      } : _app$wapp$log;
    res.status(500);
    var text = log(err, req, res);
    if (res.headersSent) {
      if (next) {
        return next(err);
      }
      return;
    }
    var config = wapp.client.config;
    var _config$siteName = config.siteName,
      siteName = _config$siteName === void 0 ? "Wapplr" : _config$siteName;
    var renderedContent = wapp.log.renderedContent({
      title: err.message + " | " + siteName,
      text: text.split("\n")[0],
      type: "content"
    });
    res.send(renderedContent);
  }
  function defaultHandle(_x, _x2, _x3) {
    return _defaultHandle.apply(this, arguments);
  }
  function _defaultHandle() {
    _defaultHandle = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee3(req, res, out) {
      var middlewares, index, next, _next;
      return (0, _regenerator2["default"])().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _next = function _next3() {
              _next = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee2(err) {
                var func, defaultArgs, args, requestMethod, requestUrl, _t;
                return (0, _regenerator2["default"])().w(function (_context2) {
                  while (1) switch (_context2.p = _context2.n) {
                    case 0:
                      if (!middlewares[index]) {
                        _context2.n = 5;
                        break;
                      }
                      func = middlewares[index];
                      index = index + 1;
                      defaultArgs = [req, res, err ? /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee() {
                        return (0, _regenerator2["default"])().w(function (_context) {
                          while (1) switch (_context.n) {
                            case 0:
                              _context.n = 1;
                              return next(err);
                            case 1:
                              return _context.a(2);
                          }
                        }, _callee);
                      })) : next];
                      args = func.length === 4 && err ? [err].concat(defaultArgs) : defaultArgs;
                      _context2.p = 1;
                      _context2.n = 2;
                      return func.apply(void 0, (0, _toConsumableArray2["default"])(args));
                    case 2:
                      return _context2.a(2, _context2.v);
                    case 3:
                      _context2.p = 3;
                      _t = _context2.v;
                      res.status(500, _t);
                      _context2.n = 4;
                      return next(_t);
                    case 4:
                      return _context2.a(2, _context2.v);
                    case 5:
                      if (!(typeof out === "function")) {
                        _context2.n = 6;
                        break;
                      }
                      index = 0;
                      return _context2.a(2, out(err));
                    case 6:
                      if (err) {
                        index = 0;
                        app.errorHandler(err, req, res, out);
                      } else if (!res.headersSent) {
                        index = 0;
                        res.status(404);
                        requestMethod = req.method;
                        requestUrl = req.url;
                        res.send(requestMethod + " " + requestUrl);
                      }
                    case 7:
                      return _context2.a(2, null);
                  }
                }, _callee2, null, [[1, 3]]);
              }));
              return _next.apply(this, arguments);
            };
            next = function _next2(_x4) {
              return _next.apply(this, arguments);
            };
            middlewares = app.middlewares;
            index = 0;
            _context3.n = 1;
            return next();
          case 1:
            return _context3.a(2, _context3.v);
        }
      }, _callee3);
    }));
    return _defaultHandle.apply(this, arguments);
  }
  function defaultUse(fn) {
    var fns = typeof fn === "function" ? [fn] : typeof fn === "object" && fn.length ? fn : [];
    if (fns.length === 0) {
      throw new TypeError("app.use() requires a middleware function");
    }
    var middlewares = app.middlewares;
    fns.forEach(function (fn, i) {
      middlewares.push(fn);
    });
    return this;
  }
  var appProperties = Object.create(Object.prototype, {
    config: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      value: defaultConfig
    }),
    middlewares: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      value: defaultMiddlewares
    }),
    errorHandler: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultErrorHandler
    }),
    handle: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultHandle
    }),
    use: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultUse
    })
  });
  function app() {
    return _app.apply(this, arguments);
  }
  function _app() {
    _app = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee4() {
      var req,
        res,
        next,
        pathname,
        search,
        hash,
        port,
        fullUrl,
        defaultOut,
        _args4 = arguments;
      return (0, _regenerator2["default"])().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            req = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
            res = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
            next = _args4.length > 2 ? _args4[2] : undefined;
            if (!(typeof app.handle === "function")) {
              _context4.n = 1;
              break;
            }
            // these properties what usually there are in req and res
            // req: path, url, hostname, protocol, secure, method, httpVersion,
            // res: statusCode
            // and a functions in res: status, send, end
            pathname = window.location.pathname || "/";
            search = window.location.search;
            hash = window.location.hash;
            port = window.location.port && !isNaN(Number(window.location.port)) ? Number(window.location.port) : window.location.port;
            req.path = req.path || window.location.pathname || "/";
            req.url = req.url || pathname + hash + search;
            req.hostname = req.hostname || port ? window.location.hostname + ":" + port : window.location.hostname;
            req.protocol = req.protocol || window.location.protocol.slice(0, window.location.protocol.length - 1);
            req.secure = req.secure || req.protocol === "https";
            req.method = req.method || "GET";
            req.httpVersion = req.httpVersion || "1.1";
            if (!req.query) {
              try {
                fullUrl = req.protocol + "://" + req.hostname + req.url;
                req.query = Object.fromEntries(new URL(fullUrl).searchParams);
              } catch (e) {}
            }
            res.statusCode = res.statusCode ? res.statusCode : 200;
            res.status = res.status || function (sc) {
              res.statusCode = sc;
              return res;
            };
            res.send = res.send || function (html, callback) {
              res.end(html, callback);
            };
            res.end = res.end || function (html, callback) {
              if (!res.headersSent) {
                Object.defineProperty(res, "headersSent", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
                  enumerable: false,
                  writable: false,
                  value: true
                }));
                res.container.innerHTML = html;
                var scripts = res.container.getElementsByTagName("script");
                var _iterator = (0, _createForOfIteratorHelper2["default"])(scripts),
                  _step;
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    var script = _step.value;
                    var parent = script.parentElement;
                    var innerHTML = script.innerHTML;
                    parent.removeChild(script);
                    var newScript = document.createElement("script");
                    newScript.type = "text/javascript";
                    newScript.innerHTML = innerHTML;
                    parent.append(newScript);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              } else {
                //throw Error
              }
              if (callback) {
                callback();
              }
            };

            // res.container (Html element) property are plus thing, usually there is not in the response
            // but is necessary for end render

            res.container = res.container || document.body;
            defaultOut = function defaultOut(err) {
              if (err) {
                return app.errorHandler(err, req, res);
              }
              var requestMethod = req.method;
              var requestUrl = req.url;
              if (!res.headersSent) {
                res.send(requestMethod + " " + requestUrl);
              }
            };
            _context4.n = 1;
            return app.handle(req, res, next || defaultOut);
          case 1:
            return _context4.a(2, app);
        }
      }, _callee4);
    }));
    return _app.apply(this, arguments);
  }
  (0, _utils.mergeProperties)(app, appProperties);
  Object.defineProperty(app, "wapp", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
    writable: false,
    enumerable: false,
    value: wapp
  }));
  return app;
}